import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useRecommendations } from "@/react/hooks/recommendations/useRecommendations";
import { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";
import { PageMetaData } from "../../Layout/PageMetaData";
import { StandardLayout } from "../../Layout/StandardLayout";
import { StandardLayoutHeaderWithPortal } from "../../Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { SpaceHeaderTitleText } from "../../Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";
import { TabNavigation } from "../shared/TabNavigation";
import { PendingConnections } from "./components/PendingConnections";
import { Recommendations } from "./components/Recommendations";

const i18nBase = "members_directory.grow";

const pendingRequestsFilter = {
  id: "connections-pending-recipient",
  key: "connections",
  status: "pending",
  role: "recipient",
};

export const Grow = () => {
  const { data: recommendations, isLoading: isLoadingRecommendations } =
    useRecommendations();

  const pendingConnectionsQuery = useAudienceInfiniteQuery({
    filters: [pendingRequestsFilter],
    perPage: 10,
  });

  const shouldHideRecommendationsHeader =
    !isLoadingRecommendations &&
    recommendations?.length === 0 &&
    !pendingConnectionsQuery.isLoading &&
    pendingConnectionsQuery.audience.length === 0;

  return (
    <>
      <StandardLayoutHeaderWithPortal
        leftContent={
          <div className="flex flex-row items-center gap-6">
            <SpaceHeaderTitleText>
              {t(`${i18nBase}.title`)}
            </SpaceHeaderTitleText>
            <TabNavigation className="m-auto" />
          </div>
        }
      />
      <StandardLayout.Body hasPaddingTopMobile={false} className="!bg-primary">
        <PageMetaData title={t(`${i18nBase}.title`)} />

        <StandardLayout.Content className={classNames("md:!min-w-0")}>
          <PendingConnections
            pendingConnectionsQuery={pendingConnectionsQuery}
          />
          <Recommendations
            recommendations={recommendations}
            isLoading={isLoadingRecommendations}
            shouldHideHeader={shouldHideRecommendationsHeader}
          />
        </StandardLayout.Content>
      </StandardLayout.Body>
    </>
  );
};
